module.exports = __webpack_public_path__ + "static/fonts/Ambrogio.1060bb32.otf";